import { z } from 'zod';

export const Me = z.object({
  user_id: z.number(),
  nextcloud_user_id: z.string(),
  display_name: z.string().nullable(),
  kind: z.enum(['phone', 'tesla']),
});
export type Me = z.infer<typeof Me>;

export const Feed = z.object({
  id: z.number(),
  url: z.string(),
  title: z.string(),
  faviconLink: z.string().nullable(),
  unreadCount: z.number(),
  folderId: z.number(),
});
export type Feed = z.infer<typeof Feed>;

export const ArticleSummary = z.object({
  id: z.number(),
  title: z.string(),
  author: z.string().nullable(),
  url: z.string(),
  feedId: z.number(),
  pubDate: z.number(),
  unread: z.boolean(),
  starred: z.boolean(),
  archived: z.boolean(),
  preview: z.string(),
  estimatedSeconds: z.number(),
  hasAudio: z.boolean(),
  playback: z
    .object({
      position: z.number(),
      duration: z.number().nullable(),
    })
    .nullable(),
});
export type ArticleSummary = z.infer<typeof ArticleSummary>;

export const PlaybackPosition = z.object({
  position: z.number(),
  duration: z.number().nullable(),
  updated_at: z.number(),
});
export type PlaybackPosition = z.infer<typeof PlaybackPosition>;

export const ArticleDetail = z.object({
  id: z.number(),
  title: z.string(),
  author: z.string().nullable(),
  url: z.string(),
  feedId: z.number(),
  pubDate: z.number(),
  unread: z.boolean(),
  starred: z.boolean(),
  archived: z.boolean(),
  paragraphs: z.array(z.string()),
  wordCount: z.number(),
  estimatedSeconds: z.number(),
  lastPosition: PlaybackPosition.nullable(),
});
export type ArticleDetail = z.infer<typeof ArticleDetail>;

export const Settings = z.object({
  voice: z.string(),
  speed: z.number(),
  workflow_mode: z.enum(['auto-prompt', 'manual']),
  theme: z.enum(['auto', 'paper', 'night']),
  language: z.enum(['de', 'en']),
  autoplay_enabled: z.boolean(),
});
export type Settings = z.infer<typeof Settings>;

export const DeviceCode = z.object({
  device_code: z.string(),
  user_code: z.string(),
  verification_uri: z.string(),
  verification_uri_complete: z.string(),
  expires_in: z.number(),
  interval: z.number(),
});
export type DeviceCode = z.infer<typeof DeviceCode>;

export const SummaryResponse = z.object({
  summary: z.string(),
  model: z.string(),
  cached: z.boolean(),
});
export type SummaryResponse = z.infer<typeof SummaryResponse>;
